var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('awesome',{attrs:{"icon":[_vm.getType, _vm.getIcon]}}):_c('i',{staticClass:"icon",class:[_vm.getType, _vm.getIcon]})}
var staticRenderFns = []

export { render, staticRenderFns }